import gql from 'graphql-tag';

export default gql`
  query DropOne($id: MongoID!) {
    DropById(_id: $id) {
      _id
      upc
      type
      name
      store
      createdAt
      quantity
      address
      status
      quantity
      price
      product {
        imageURL
        whereToFind
        department
        actualImageURL
        hotness
        comment
        actualUPC
      }
    }
  }
`;
